import React, { useState } from 'react';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode'; // Adicione a importação do jwtDecode
import { authBaseUrl } from '../../config/runtime';
import '../../styles/Auth.css';

const Login = ({ onLogin, onToggle }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    axios.post(`${authBaseUrl}/login`, { email, password })
      .then(response => {
        const token = response.data.access_token;
        localStorage.setItem('token', token);

        const decoded = jwtDecode(token);
        const extractedEmail = decoded.sub.email || email;
        const extractedName = decoded.sub.name || extractedEmail;
        const extractedRole = decoded.sub.role;
        const extractedCompanyCode = decoded.sub.company_code;
        const extractedDepartment = decoded.sub.department || 'operacional';
        const extractedActiveArea = decoded.sub.active_area || (extractedRole === 'admin' || extractedRole === 'master' ? 'full' : extractedDepartment);
        const availableAreas = Array.isArray(response?.data?.user?.available_areas)
          ? response.data.user.available_areas
          : [extractedDepartment];

        localStorage.setItem('attendantName', extractedName);
        localStorage.setItem('userId', extractedEmail);
        if (extractedRole) {
          localStorage.setItem('role', extractedRole);
        }
        if (extractedCompanyCode) {
          localStorage.setItem('companyCode', extractedCompanyCode);
          axios.defaults.headers.common['X-Company-Code'] = extractedCompanyCode;
        }
        localStorage.setItem('department', extractedDepartment);
        localStorage.setItem('activeArea', extractedActiveArea);
        localStorage.setItem('availableAreas', JSON.stringify(availableAreas));
        localStorage.setItem('pendingAreaSelection', '1');
        onLogin();
        window.location.reload();
      })
      .catch((error) => {
        const msg = error?.response?.data?.message || 'E-mail ou senha incorretos.';
        setErrorMessage(msg);
      });
  };

  return (
    <form className="auth-form" onSubmit={handleSubmit}>
      <h2>Login</h2>
      <div className="auth-form-logo">
        <img src="/logo-nextdevelop.jpeg" alt="Next Develop" />
      </div>
      {errorMessage && <div className="error-message">{errorMessage}</div>}
      <div>
        <label>E-mail</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="seuemail@empresa.com"
        />
      </div>
      <div>
        <label>Senha</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
      </div>
      <button type="submit">Login</button>
      <p>Não tem uma conta? <button type="button" onClick={onToggle} className="link-button">Registre-se</button></p>
    </form>
  );
};

export default Login;
